import { createRouter, createWebHistory } from 'vue-router';
// ya no usamos validateToken ni authService de Sanctum
// import { validateToken } from '@/services/api/authService';

//import keycloak, { login as keycloakLogin } from '@/services/api/keycloak';

import MainLayout from '../layouts/MainLayout.vue';
import HomeView from '../views/HomeView.vue';
import PreciosView from '../views/precios/PreciosView.vue';
import DirectorView from '../views/director/DirectorView.vue';
import LoginView from '../views/LoginView.vue'; // <-- ahora usamos el LoginView con Keycloak
import IndicesView from '../views/indices/IndicesView.vue';
import ContenidoView from '../views/contenidos/ContenidoView.vue';
import ViewTable from '../views/vistas/ViewActions.vue';
import ConcessionaireFormView from '../views/administrador/concesionarios/ConcessionaireFormView.vue';
import RegionalesView from '../views/administrador/ajustes/RegionalsView.vue';
import ProvinciasView from '../views/administrador/ajustes/ProvincesView.vue';
import AreasView from '../views/administrador/ajustes/AreasView.vue';
import CargosView from '../views/administrador/ajustes/PositionView.vue';
import ConcessionaireView from '../views/administrador/concesionarios/ConcessionaireView.vue';
import UserFormView from '../views/administrador/usuarios/UserFormView.vue';
import RegistrationView from '../views/administrador/solicitudes-acceso/RegistrationView.vue';
import PermisosView from '../views/administrador/permisos/PermisosView.vue';
import ConventionView from '../views/administrador/eventos/ConventionView.vue';
import ConferenceView from '../views/administrador/eventos/ConferenceView.vue';
import ConferenceFormView from '../views/administrador/eventos/ConferenceFormView.vue';
import BrandsView from '../views/administrador/ajustes/BrandsView.vue';

import store from '@/store';
import { fetchCurrentUser } from '@/services/api/user';
import Swal from 'sweetalert2';
import keycloak, { login as keycloakLogin, logout as keycloakLogout } from '@/services/api/keycloak';


const routes = [
  {
    path: '/',
    redirect: '/main', // antes te mandaba a /login, ahora la protección la hace Keycloak
  },
  {
    path: '/main',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView,
        meta: { requiresAuth: true },
      },
      {
        path: 'novedades',
        name: 'Novedades',
        component: () =>
          import(
            /* webpackChunkName: "novedades" */ '../views/novedades/NovedadesView.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'precios/:subMenu',
        name: 'PreciosSubMenu',
        component: PreciosView,
        meta: { requiresAuth: true },
      },
      {
        path: 'director/:subMenu',
        name: 'DirectorSubMenu',
        component: DirectorView,
        meta: { requiresAuth: true },
      },
      {
        path: 'contenidos/:subMenu',
        name: 'ContenidoView',
        component: ContenidoView,
        meta: { requiresAuth: true },
      },
      {
        path: 'indices',
        name: 'Indices',
        component: IndicesView,
        props: { menu: 'indices' },
        meta: { requiresAuth: true },
      },
      {
        path: 'vista',
        name: 'Vista',
        component: ViewTable,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/:subMenu',
        name: 'AdministradorSubMenu',
        component: () =>
          import(
            /* webpackChunkName: "administrador" */ '../views/administrador/AdministradorView.vue'
          ),
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: '/concessionaires-alta',
        name: 'ConcessionaireForm',
        component: ConcessionaireFormView,
        meta: { requiresAuth: true },
      },
      {
        path: '/usuario-alta',
        name: 'UserForm',
        component: UserFormView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/regionales',
        name: 'Regionales',
        component: RegionalesView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/provincias',
        name: 'Provincias',
        component: ProvinciasView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/areas',
        name: 'Areas',
        component: AreasView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/cargos',
        name: 'Cargos',
        component: CargosView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/marcas',
        name: 'Marcas',
        component: BrandsView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/convenciones',
        name: 'Convention',
        component: ConventionView,
        meta: { requiresAuth: true },
      },
      {
        path: '/administrador/eventos/:id/jornadas',
        name: 'Conference',
        component: ConferenceView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/convenciones/nueva',
        name: 'NuevaConvencion',
        component: () =>
          import('@/views/administrador/eventos/ConventionFormView.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/ajustes/convenciones/:id/editar',
        name: 'EditarConvencion',
        component: () =>
          import('@/views/administrador/eventos/ConventionFormView.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/administrador/eventos/:id/jornadas/nueva',
        name: 'ConferenceForm',
        component: ConferenceFormView,
        meta: { requiresAuth: true },
      },
      {
        path: '/administrador/eventos/:id/jornadas/:conferenceId/editar',
        name: 'ConferenceEditForm',
        component: ConferenceFormView,
        meta: { requiresAuth: true },
      },
      {
        path: '/administrador/concesionarios/editar',
        name: 'ConcessionaireFormStepTwo',
        meta: { requiresAuth: true },
        component: () =>
          import(
            '@/views/administrador/concesionarios/ConcessionaireFormStepTwo.vue'
          ),
        props: (route) => ({
          isEditing: route.query.isEditing === 'true',
          isAddBranch: route.query.isAddBranch === 'true',
          currentConcessionaireType: route.query.type
            ? parseInt(route.query.type)
            : null,
        }),
      },
      {
        path: '/administrador/usuarios/editar',
        name: 'UserEdit', // Le cambiamos el nombre para ser más claros (antes UserFormStepTwo)
        meta: { requiresAuth: true },
        component: UserFormView, // Reutilizamos el MISMO componente unificado
        props: (route) => ({
          isEditing: true, // Forzamos modo edición
          userId: route.query.userId // Pasamos el ID si viene por query (opcional, tu componente ya lee query)
        }),
      },
      {
        path: 'administrador/concessionaires/grupos-economicos',
        name: 'EconomicGroups',
        component: () =>
          import(
            '../views/administrador/concesionarios/grupos-economicos/EconomicGroupsView.vue'
          ),
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/concessionaires/:subMenu',
        name: 'ConcessionaireSubMenu',
        component: ConcessionaireView,
        meta: { requiresAuth: true },
        props: true,
      },
      {
        path: 'administrador/solicitudes-acceso',
        name: 'Registration',
        component: RegistrationView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/permisos-usuarios',
        name: 'Permisos',
        component: PermisosView,
        meta: { requiresAuth: true },
      },
      {
        path: 'administrador/circulares/form',
        name: 'CircularForm',
        component: () =>
          import('@/views/administrador/circulares/CircularFormView.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView, // este ahora es el "puente" con Keycloak
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    if (to.name === 'login' && keycloak.authenticated) {
      return next({ name: 'home' });
    }
    return next();
  }

  if (!keycloak.authenticated) {
    console.warn('No autenticado: redirigiendo a Keycloak.');
    try {
      await keycloakLogin({ redirectUri: window.location.origin + to.fullPath });
    } catch (error) {
      console.error('Error iniciando login en Keycloak desde router:', error);
      return next({ name: 'login' });
    }
    return;
  }

  // Usuario Autenticado en Keycloak: Validar permisos locales
  if (!store.state.userData) {
    try {
      const userDataResponse = await fetchCurrentUser();
      const user = userDataResponse.data || userDataResponse;

      const hasAccess = user.roles && user.roles.some(role => role.name === 'general-admin' || role.name === 'change-prices');

      if (!hasAccess) {
        console.warn('Bloqueo por frontend: El usuario no es general-admin ni change-prices en Laravel');

        await Swal.fire({
          icon: 'error',
          title: 'Acceso Denegado',
          text: 'No posees los permisos de Administrador General para ingresar a esta plataforma.',
          confirmButtonText: 'Salir',
          allowOutsideClick: false,
          allowEscapeKey: false
        });

        keycloakLogout({ redirectUri: window.location.origin + '/login' });
        return;
      }

      store.dispatch("updateUserData", user);

    } catch (error) {
      console.error("Error al obtener los datos del usuario desde Laravel:", error);
      keycloakLogout({ redirectUri: window.location.origin + '/login' });
      return;
    }
  }

  return next();
});

export default router;
